export const SET_SELECTED = 'sidebar.item.SET_SELECTED';
